import { NameDto } from 'api/Common/Types'
import { store } from 'store/store'

export enum ClientTypeEnum {
  INDIVIDUAL = 'Individual',
  COMPANY = 'Company',
  NONE = 'None',
}

export enum ClientStatusId {
  PENDING_VERIFICATION = 1,
  EMAIL_VERIFIED = 2,
  PENDING_DOCUMENT_VERIFICATION = 3,
  ACTIVATED = 4,
  VALIDATION_DENIED = 5,
  BLOCKED = 6,
  DORMANT = 7,
  CLOSED = 8,
}

export enum ClientStatus {
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  PENDING_DOCUMENT_VERIFICATION = 'PENDING_DOCUMENT_VERIFICATION',
  ACTIVATED = 'ACTIVATED',
  VALIDATION_DENIED = 'VALIDATION_DENIED',
  BLOCKED = 'BLOCKED',
  DORMANT = 'DORMANT',
  UNKNOWN = 'UNKNOWN',
  CLOSED = 'CLOSED',
}

const EconomicProfileReadOnlyStatuses = new Set<number>([
  ClientStatusId.ACTIVATED,
  ClientStatusId.DORMANT,
  ClientStatusId.BLOCKED,
  ClientStatusId.VALIDATION_DENIED,
  ClientStatusId.CLOSED,
])

export const isClientStatusActivated = (clientStatus: {
  id: ClientStatusId
  name: string
}): boolean => {
  return getClientStatus(clientStatus) === ClientStatus.ACTIVATED
}

export function typeOfClient(clientType: NameDto): ClientTypeEnum {
  const types = store.getState().clients.types
  if (types.length > 0) {
    const match = types.find((t) => t.id === clientType.id)
    if (match) {
      return match.name as ClientTypeEnum
    } else {
      return ClientTypeEnum.NONE
    }
  }
  return ClientTypeEnum.NONE
}

export function getClientStatus(clientStatus: { id: ClientStatusId; name: string }): ClientStatus {
  switch (clientStatus.id) {
    case ClientStatusId.ACTIVATED:
      return ClientStatus.ACTIVATED
    case ClientStatusId.BLOCKED:
      return ClientStatus.BLOCKED
    case ClientStatusId.DORMANT:
      return ClientStatus.DORMANT
    case ClientStatusId.EMAIL_VERIFIED:
      return ClientStatus.EMAIL_VERIFIED
    case ClientStatusId.PENDING_VERIFICATION:
      return ClientStatus.PENDING_VERIFICATION
    case ClientStatusId.PENDING_DOCUMENT_VERIFICATION:
      return ClientStatus.PENDING_DOCUMENT_VERIFICATION
    case ClientStatusId.VALIDATION_DENIED:
      return ClientStatus.VALIDATION_DENIED
    default:
      return ClientStatus.UNKNOWN
  }
}

export const canEditEconomicProfileTestForClientStatus = (
  clientStatusId?: ClientStatusId
): boolean => {
  if (!clientStatusId) return true
  return !EconomicProfileReadOnlyStatuses.has(clientStatusId)
}
